import { Component, Inject } from '@angular/core';
import { MaterialModule } from 'src/app/app-material.module';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dettaglio-corsi',
  templateUrl: './dettaglio-corsi.component.html',
  styleUrls: ['./dettaglio-corsi.component.scss'],
  standalone: true,
  imports: [FormsModule, MaterialModule]
})
export class DettaglioCorsiComponent {

  constructor(
    public dialogRef: MatDialogRef<DettaglioCorsiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog) {
  }

  isDisabled = true;
  title = this.data.title;
  corso = this.data.corso;


}
